/**
 * The Developers panel screens a docs page may name as a step — a bold path such as
 * **Panel › Developers › Keys** (design §0.4) — and where each one is. The build stops on a step
 * that names no screen here (`site.mjs`), and the site links each step to its screen (`remarkDocs`).
 *
 * The panel is the app's (another site once the docs move out, K104), so this list is the docs' side
 * of that contract. The app's own label list is `src/pages/DevelopersPage/panelRegistry.ts`; while
 * both live in one repo a test there keeps the two equal (MOVE.md: it goes with the move).
 */
import { DEVELOPER_LINKS } from "./links";

export interface PanelScreen {
  id: string;
  /** The label path after "Panel" (e.g. ["Developers", "Keys"]). */
  label: readonly string[];
  /** Under the panel's address; "" is the panel's root. */
  slug: string;
}

export const PANEL_SCREENS: readonly PanelScreen[] = [
  { id: "overview", label: ["Developers", "Overview"], slug: "" },
  { id: "keys", label: ["Developers", "Keys"], slug: "keys" },
  { id: "webhooks", label: ["Developers", "Webhooks"], slug: "webhooks" },
  { id: "jobs", label: ["Developers", "Jobs"], slug: "jobs" },
  { id: "request-log", label: ["Developers", "Request log"], slug: "request-log" },
  { id: "usage", label: ["Developers", "Usage"], slug: "usage" },
  { id: "metrics", label: ["Developers", "Metrics"], slug: "metrics" },
  { id: "errors", label: ["Developers", "Errors"], slug: "errors" },
  { id: "limits", label: ["Developers", "Limits"], slug: "limits" },
  { id: "files", label: ["Developers", "Files & records"], slug: "files" },
  { id: "billing", label: ["Billing"], slug: "billing" },
  { id: "team", label: ["Team"], slug: "team" },
];

/** "Panel › Developers › Keys" — the docs' spelling of a screen. */
export const panelPath = (screen: PanelScreen): string => ["Panel", ...screen.label].join(" › ");

/** The screen a docs "Panel › …" path names, or undefined when no screen has that label. */
export const entryOfPath = (path: string): PanelScreen | undefined => PANEL_SCREENS.find((s) => panelPath(s) === path.trim());

/** The URL of one screen. */
export const panelUrl = (id: string): string => {
  const slug = PANEL_SCREENS.find((s) => s.id === id)?.slug ?? "";

  return [DEVELOPER_LINKS.panel, slug].filter(Boolean).join("/");
};
